/* DeleteAction.js */

"use strict";

const DEVICE_NAME_MAX_LENGTH = 60;
const DEVICE_NAME_LIST_LENGTH = 10;

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, ConfigAuditPolicy) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._configAuditPolicy = ConfigAuditPolicy;
        this._selectedPolicyIds = [];
        this._selectedPolicyNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedPolicyIds = this._activeView.getSelectedPolicyIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPolicyIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedPolicyIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getPolicyEntitiesNameById(this._selectedPolicyIds);
                    }
                    return Promise.resolve();
                })
                .then((selectedPolicyNames) => {
                    this._selectedPolicyNames = selectedPolicyNames;
                    if (this._selectedPolicyIds.length <= DEVICE_NAME_LIST_LENGTH) {
                        if (Array.isArray(this._selectedPolicyNames) && this._selectedPolicyNames.length > 0) {
                            let s = this._selectedPolicyNames.length > 1 ? "s" : "";
                            this._message = "Are you sure you want to permanently delete the selected policy" + s + "?\n";
                            Object.keys(this._selectedPolicyNames).forEach((id) => {
                                let policyName = this._selectedPolicyNames[id];
                                let shortPolicyName =
                                    policyName.length > DEVICE_NAME_MAX_LENGTH ? policyName.substr(0, DEVICE_NAME_MAX_LENGTH) + "…" : policyName;
                                this._message += "\n" + shortPolicyName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected polices"));
                        }
                    } else {
                        this._message = `Are you sure you want to permanently delete the selected ${this._selectedPolicyIds.length} polices?\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Delete",
                            confirmDetails: {
                                text: "Confirm",
                                type: "destructive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            let workTarget = {
                                method: "multi",
                                ids: this._selectedPolicyIds
                            };
                            const showProgFunc = (prog) => {
                                this._modalUserFeedback.showLoadingProgress(`${prog.successCount} of ${prog.targetCount}`);
                            };
                            return this._configAuditPolicy
                                .runDeleteConfigAuditPoliciesWork(this._activeOrgId, workTarget, { launchAndForget: false }, showProgFunc)
                                .then((workResults) => {
                                    this._configAuditPolicy.throwWorkErrors(workResults);
                                    this._activeView.resetSelection();

                                    return Promise.resolve();
                                });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.ConfigAuditPolicy"
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete policies",
    order: 5
};
